/**
 * Created by Yoyo Fang on 06/12/2020.
 * Description:
 *
 * ------ maintenance history ------
 */

import { NgModule } from '@angular/core';

import { IntralinksModule } from './intralinks/intralinks.module';
import { BlastEmailModule } from './blastemail/blastemail.module';
import { FeedsRoutingModule } from './feeds-routing.module';

@NgModule({
    imports: [
        IntralinksModule,
        BlastEmailModule,
        FeedsRoutingModule
    ],
    declarations: [
    ],
    exports: [
    ]
})
export class FeedsModule { }
